import RoundIcon from "@/Atoms/RoundIcon";
import React, {useRef} from "react";
import styles from './SharePerson.module.scss'
import {Person} from "@/types/person";
import environment from "@/helpers/environment";


export default ({person}: {person: Person}) => {


  const anchorRef = useRef<HTMLAnchorElement|null>(null);
  const handleCopyUrl = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    const current = anchorRef.current;
    if (anchorRef.current === null){
      return;
    }
    const href = current?.getAttribute('href') as string;
    current?.classList.toggle(styles.copied, true)
    setTimeout(() => current?.classList.toggle(styles.copied, false), 2000)
    copyUrl(href)


  }
  const copyUrl = (value: string) => {
    const inp = document.createElement('input');
    document.body.appendChild(inp)
    inp.value = value
    inp.select();
    document.execCommand('copy',false);
    inp.remove();
  }
  const baseUrl = environment.getString('VITE_APP_URL')
  // const url = `${baseUrl}/overlijdensberichten/${person.slug}`
  const url = person.link

  return <div className={styles.socials}>
    <span className={styles.title}>Deel pagina via</span>
    <div className={styles.icons}>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}>
        <RoundIcon dark icon={<i className="fa-brands fa-facebook-f"></i>}/>
      </a>
      <a href={`https://wa.me/?text=${url}`}>
        <RoundIcon dark icon={<i className="fa-brands fa-whatsapp"></i>}/>
      </a>
      <a href={`mailto:?body=${url}`}>
        <RoundIcon dark icon={<i className="fa-regular fa-envelope"></i>}/>
      </a>
      <a ref={anchorRef} data-copytext={'De url is gekopieerd'} className={styles.link} href={url} onClick={(e) => handleCopyUrl(e)}>
        <RoundIcon dark icon={<i className="fa-solid fa-link"></i>}/>
      </a>
    </div>
  </div>
}
